// extracted by mini-css-extract-plugin
export var box = "Container-module--box--cda05";
export var box_md = "Container-module--box_md--80b0e";
export var box_xmd = "Container-module--box_xmd--d5955";
export var box_flex = "Container-module--box_flex--b1734";
export var box_lg = "Container-module--box_lg--97141";
export var box_sm = "Container-module--box_sm--afd6c";
export var box_outer = "Container-module--box_outer--d936d";
export var box_whiteBg = "Container-module--box_white-bg--739fb";
export var box_noMarginBottom = "Container-module--box_no-margin-bottom--31c96";
export var box_noPadding = "Container-module--box_no-padding--bb6cc";
export var box_outerGray = "Container-module--box_outer-gray--49beb";
export var box_dark = "Container-module--box_dark--dfaef";
export var box_zIndex = "Container-module--box_z-index--ca9e5";
export var box_zIndex6 = "Container-module--box_z-index-6--a0dad";
export var box_eventsWithLine = "Container-module--box_events-with-line--99647";
export var box_featuresAo = "Container-module--box_features-ao--6a60d";
export var box_verticalPaddings = "Container-module--box_vertical-paddings--4e66b";
export var clearP = "Container-module--clearP--0346f";
export var clearP_vc = "Container-module--clearP_vc--6d57e";
export var container = "Container-module--container--7fee3";
export var marginTop = "Container-module--marginTop--5b3a5";
export var paddingTopWithoutBottom = "Container-module--paddingTopWithoutBottom--16132";
export var paddingTopWithBottom = "Container-module--paddingTopWithBottom--8c2bb";
export var marginNone = "Container-module--marginNone--d0e99";
export var paddingWithout = "Container-module--paddingWithout--06702";
export var paddingXL = "Container-module--paddingXL--d5f9d";
export var paddingVertical = "Container-module--paddingVertical--9ed74";
export var paddingHorizontal = "Container-module--paddingHorizontal--0a8c0";
export var paddingBottomNone = "Container-module--paddingBottomNone--23f25";
export var paddingTopNone = "Container-module--paddingTopNone--ef967";
export var paddingOnlyTop = "Container-module--paddingOnlyTop--20163";
export var inner = "Container-module--inner--d49e3";
export var whiteBG = "Container-module--whiteBG--209fb";
export var transparentBG = "Container-module--transparentBG--2da28";
export var transparent02BG = "Container-module--transparent02BG--e79fa";
export var grayBG = "Container-module--grayBG--a7ed0";
export var lightGrayBG = "Container-module--lightGrayBG--25e7c";
export var smokyBG = "Container-module--smokyBG--e6dc6";
export var darkPrimaryBG = "Container-module--darkPrimaryBG--10c59";
export var fadeInAnimation = "Container-module--fadeInAnimation--f720c";
export var placeHolderShimmer = "Container-module--placeHolderShimmer--7559b";